import { ApplicationRef, Injectable, NgZone } from '@angular/core';
import { consoleHelper } from 'lib/helpers/console-helper.class.js';
import { PlatformService } from 'lib/platform/index.js';
import { BehaviorSubject, first, map } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class AppStableService {
	public readonly appIsStable_ = new BehaviorSubject<boolean>(false);

	constructor(readonly appRef: ApplicationRef, readonly ngZone: NgZone, readonly platformService: PlatformService) {
		appRef.isStable
			.pipe(
				first((stable) => {
					return stable;
				}),
				map(() => {
					// run in ngZone as appRef.isStable runs outside Angular zone
					ngZone.run(() => {
						// app is table now
						// only log in browsers
						if (platformService.isBrowser) {
							consoleHelper.logToConsole({
								type: 'Info',
								message: 'App is stable'
							});
						}

						this.appIsStable_.next(true);
					});
				})
			)
			.subscribe();
	}
}
